import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllPaystackEvents } from "../thunk";

interface UserDetails {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  id: string;
}

interface PaystackEvent {
  _id: string;
  userId: UserDetails;
  transactionReference: string;
  amount: number;
  message: string;
  createdAt: string;
  __v: number;
}

interface PaystackState {
  events: PaystackEvent[];
  count: number;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: PaystackState = {
  events: [],
  count: 0,
  status: "idle",
  error: null,
};

const paystackSlice = createSlice({
  name: "paystack",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllPaystackEvents.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllPaystackEvents.fulfilled, (state, action: PayloadAction<{ success: boolean; count: number; data: PaystackEvent[] }>) => {
        state.status = "succeeded";
        state.events = action.payload.data;
        state.count = action.payload.count;
        state.error = null;
      })
      .addCase(getAllPaystackEvents.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string || "Failed to fetch paystack events";
      });
  },
});

export default paystackSlice.reducer;
